module.exports = __webpack_public_path__ + "static/media/screenshot.0d4687d0.JPG";